module.exports = __webpack_public_path__ + "img/artboard–3.177917da.png";